import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import Vuelidate from 'vuelidate'
import vuetify from './plugins/vuetify'
import { i18n } from './plugins/i18n'
import apiUrls from './constants/urls'
import moment from 'moment'
import _ from 'lodash'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

Sentry.init({
  dsn: 'https://870f1901a5ca49c6aa6eb93db4162f25@sentry.amplitudes.co/3',
  integrations: [
    new Integrations.Vue({ Vue, attachProps: true, logErrors: true })
  ],
  environment: process.env.NODE_ENV
})

Vue.use(Vuelidate)

moment.locale('fr')
Vue.prototype.$moment = moment
Vue.prototype.$_ = _

Vue.config.productionTip = false

new Vue({
  store,
  router,
  vuetify,
  i18n,
  apiUrls,
  render: h => h(App)
}).$mount('#app')
